module.exports = __webpack_public_path__ + "img/pr2.690b0774.png";